/**
 * Insert un fichier CSS ou JS dans le head.
 */
function ff_load_file(file_src, file_type, file_id) {
  let file_ref;

  // Javascript
  if (file_type == 'js') {
    const existing_script = document.querySelector(`script[src='${file_src}']`);
    if (existing_script) file_ref = existing_script;
    else file_ref = document.createElement('script');

    file_ref.setAttribute('type', 'text/javascript');
    file_ref.setAttribute('src', file_src);
    file_ref.setAttribute('id', file_id);
  }

  // CSS
  else if (file_type == 'css') {
    const existing_css = document.querySelector(`link[href='${file_src}']`);
    if (existing_css) file_ref = existing_css;
    else file_ref = document.createElement('link');

    file_ref.setAttribute('rel', 'stylesheet');
    file_ref.setAttribute('type', 'text/css');
    file_ref.setAttribute('href', file_src);
    file_ref.setAttribute('id', file_id);

  }
  if (typeof file_ref != 'undefined') {
    document.getElementsByTagName('head')[0].prepend(file_ref);
  }
}

// Exportation
export { ff_load_file }; // eslint-disable-line import/prefer-default-export
